import { Component, computed, OnInit, effect, inject, input, PLATFORM_ID } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MainHeaderComponent } from '../main-header/main-header.component';
import { MainFooterComponent } from '../main-footer/main-footer.component';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService, LOGIN_TYPE_COMPLETE_REGISTRATION, LOGIN_TYPE_PASSWORD_RESET } from '../../../../services/authentication/auth.service';
import { CookiesDisabledBannerComponent } from "../../../cookies-disabled-banner/cookies-disabled-banner.component";

@Component({
  selector: 'app-homepage',
  imports: [
    CommonModule,
    MainFooterComponent,
    MainHeaderComponent,
    ProgressSpinnerModule,
    RouterOutlet,
    CookiesDisabledBannerComponent,
],
  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.scss'
})
export class HomepageComponent implements OnInit {
  private authService = inject(AuthService);
  private platformId = inject(PLATFORM_ID);

  public passwordResetToken = input('');
  public registrationToken = input('');

  homePageData = computed(() => this.apiService.mainHomePageModelSignal());

  constructor(private apiService: ApiService, private router: Router) {

    effect(() => {
      if (this.homePageData()) {
         // console.log('HomepageComponent: page is loaded');
      }
    });
  }

  ngOnInit() {

    //this.router.navigate(['account-info']);

    if (this.homePageData() == false) {
      this.apiService.getHomePageData('todo:');
    }

    if (this.passwordResetToken() != undefined && this.passwordResetToken() !== "") {
      this.openPasswordResetModal(this.passwordResetToken());
    } else if (this.registrationToken() != undefined && this.registrationToken() !== "") {
      this.openCompleteRegistrationModal(this.registrationToken());
    }

  }

  protected openPasswordResetModal(passwordResetToken: string) {
    if (isPlatformBrowser(this.platformId)) {
      this.authService.openLoginModal(LOGIN_TYPE_PASSWORD_RESET, () => { }, 0, () => { }, passwordResetToken);
    }
  }

  protected openCompleteRegistrationModal(registrationToken: string) {
      if (isPlatformBrowser(this.platformId)) {
        this.authService.openLoginModal(LOGIN_TYPE_COMPLETE_REGISTRATION, () => { }, 0, () => { }, registrationToken);
      }
    }
}
